import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCuIdtXmfM7GsdgWKCMWgl_20JMTp0E4K8",
    authDomain: "icaseoeste-61256.firebaseapp.com",
    projectId: "icaseoeste-61256",
    storageBucket: "icaseoeste-61256.firebasestorage.app",
    messagingSenderId: "302879278055",
    appId: "1:302879278055:web:c69ccd22bd376553847342",
    measurementId: "G-VD83LXY0GV"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;